import React from 'react';
//@ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';
//@ts-ignore
import {BaseUrl} from './../../themes/kent/utilities/functions';
//@ts-ignore
//import {GetLocalText} from './../../themes/kent/utilities/functions';
import HeaderCategoryMenu from './header-category-menu';
import HeaderLineMenu from './header-line-menu';
import HeaderSearch from './header-search';
import HeaderMenuItem from './header-menu-item';
import StickyHeader from './../sticky-header/./sticky-header';
import TextOverImageThumb from './../text-over-image-thumb/./text-over-image-thumb';
//@ts-ignore
import Collapsible from 'react-collapsible';

/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  categories?: any;
  lines?: any;
  logo?:any;
  site?:any;
  menuItems?:any;
  hideSearch?:any;
  hideCart?:any;
  categoryColumns?:any;
  lineColumns?:any;
}

interface IState {
  searchActive:boolean;
  productText:string;
  categoryMenuActive:boolean;
  lineMenuActive:boolean;
  hover?:boolean;
  baseUrl?:any;
  mobileMenuActive:boolean;
}

class HeaderWrapper extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      searchActive:false,
      productText:'products',
      categoryMenuActive:false,
      lineMenuActive:false,
      mobileMenuActive:false
    }
  }
  componentDidMount = async() =>{
    //let productText = await GetLocalText('products');
    let url = await BaseUrl();
    this.setState({
      baseUrl:url
    })
  }
  public hover = () => {
    this.setState({
      hover: true
    })
  }
  public delayedToggleSearch = () => {
    setTimeout(() => {
      this.toggleSearch();
    }, 500);
  }
  public toggleSearch = () => {
    this.setState({
      searchActive: this.state.searchActive ? false : true
    })
  }
  public toggleCategoryMenu = () => {
    this.setState({
      categoryMenuActive: this.state.categoryMenuActive ? false : true
    })
  }
  public toggleLineMenu = () => {
    this.setState({
      lineMenuActive: this.state.lineMenuActive ? false : true
    })
  }
  public toggleMobileMenu = () => {
    this.setState({
      mobileMenuActive: this.state.mobileMenuActive ? false : true
    })
  }



  public render(): JSX.Element {
    let searchAsset: string = this.props.site == 'hosports' ? GeneralAssetUrl+'search-black.png' : GeneralAssetUrl+'search-white.png';
    let menuAsset: string = this.props.site == 'hosports' ? GeneralAssetUrl+'menu-black.png' : GeneralAssetUrl+'menu-white.png';
    let hoverClass:string = ""
    let mobileActive:string = ""
    if(this.state.mobileMenuActive){
      mobileActive = "enabled";
    }
    let categories:any = null;
    let lines:any = null;
    if(this.props.categories && this.props.categories.length > 0){
      categories = [];
      this.props.categories.map((category:any) =>{
        let link:string = '';
        if(category.link){
          if(category.link.linkUrl){
            link = category.link.linkUrl.destinationUrl;
          }
        }
        categories.push({
          text:category.link ? category.link.linkText :'',
          image:category.image ? category.image.src :'',
          link:link
        })
      })
    }
    if(this.props.lines && this.props.lines.length > 0){
      lines = [];
      this.props.lines.map((line:any) =>{
        let image:string = '';
        let title:string = 'Line Title';
        let link:string = '/';
        let linkArray:any = [];
        let collabsibleCategoryLinks:any = [];
        if(line.image){
          image = line.image.src;
        }
        if(line.title){
          title = line.title
        }
        if(line.link && line.link.linkUrl){
          link = line.link.linkUrl.destinationUrl;
        }
        if(line.links){
          for (let i = 0; i < line.links.length; i++) {
            let link:string = '';
            let text:string = '';
            if(line.links[i].linkUrl){
              link = line.links[i].linkUrl.destinationUrl;
            }
            if(line.links[i].linkText){
              text = line.links[i].linkText;
            }
            linkArray.push({
              text:text,
              url:link
            })
          }
        }
        if(line.collabsibleCategoryLinks){
          for (let i = 0; i < line.collabsibleCategoryLinks.length; i++) {
            let collabsibleCategoryLink:any = line.collabsibleCategoryLinks[i];
            let link:string = '';
            let text:string = '';
            let links:any = [];
            if(collabsibleCategoryLink.link){
              if(collabsibleCategoryLink.link.linkUrl){
                link = collabsibleCategoryLink.link.linkUrl.destinationUrl;
              }
            }

            if(collabsibleCategoryLink.title){
              text = collabsibleCategoryLink.title;
            }
            if(collabsibleCategoryLink.links){
              for (let x = 0; x < collabsibleCategoryLink.links.length; x++) {
                let collabsibleCategoryLinkItem:any = collabsibleCategoryLink.links[x];
                let link:string = '';
                let text:string = '';
                if(collabsibleCategoryLinkItem.linkUrl){
                  link = collabsibleCategoryLinkItem.linkUrl.destinationUrl;
                }
                if(collabsibleCategoryLinkItem.linkText){
                  text = collabsibleCategoryLinkItem.linkText;
                }
                links.push({
                  text:text,
                  url:link
                })
              }
            }
            collabsibleCategoryLinks.push({
              text:text,
              url:link,
              links:links
            })
          }
        }
        lines.push({
          title:title,
          link:link,
          image:image,
          links:linkArray,
          collabsibleCategoryLinks:collabsibleCategoryLinks
        })
      })
    }
    return (
    <StickyHeader>
      <>
       <div className={"header-wrapper header-desktop "+hoverClass+ " "+this.props.site} onMouseEnter={this.hover}>
         {this.props.site == "hyperlite" &&
           <div className="dark-grey-background site-switcher">
             <a className="site-switcher-logo black-background" href="/">
               <img alt="" src={GeneralAssetUrl+"site-switcher-hyperlite.png"} />
             </a>
             <a className="site-switcher-logo" href="https://www.fatsac.com">
               <img className="subheading" alt="" src={GeneralAssetUrl+"site-switcher-fatsac.png"} />
             </a>
           </div>
         }
         {this.props.site == "fatsac" &&
           <div className="dark-grey-background site-switcher">
             <a className="site-switcher-logo black-background" href="/">
               <img alt="" src={GeneralAssetUrl+"site-switcher-fatsac.png"} />
             </a>
             <a className="site-switcher-logo" href="https://www.hyperlite.com">
               <img className="subheading" alt="" src={GeneralAssetUrl+"site-switcher-hyperlite.png"} />
             </a>
             <a className="site-switcher-logo" href="https://www.barefootinternational.com">
               <img className="subheading" alt="" src={GeneralAssetUrl+"site-switcher-barefoot.png"} />
             </a>
           </div>
         }
         {this.props.site == "barefootinternational" &&
           <div className="dark-grey-background site-switcher">
             <a className="site-switcher-logo  black-background" href="/">
               <img className="subheading" alt="" src={GeneralAssetUrl+"site-switcher-barefoot.png"} />
             </a>
             <a className="site-switcher-logo" href="https://www.fatsac.com">
               <img alt="" src={GeneralAssetUrl+"site-switcher-fatsac.png"} />
             </a>
           </div>
         }
         <div className="header-wrapper-content">
           {this.props.logo && <a href={this.state.baseUrl}><img className="header-logo" src={this.props.logo} /></a>}
           <div className="header-menu">
            {(this.props.categories && this.props.categories.length > 0) && <div className="header-menu-item" onClick={this.toggleCategoryMenu}>{this.state.productText}</div>}
            {(this.props.lines && this.props.lines.length > 0) && <div className="header-menu-item" onClick={this.toggleLineMenu}>{this.state.productText}</div>}
            {this.props.menuItems && this.props.menuItems.map((item:any)=>{
              return(
                <HeaderMenuItem text={item.link ? item.link.linkText:''} link={(item.link && item.link.linkUrl) ? item.link.linkUrl.destinationUrl:''} subMenu={item.subMenuArray} />
              )
            })}
           </div>
           {!this.props.hideSearch && <img onClick={this.toggleSearch} className="header-icon" src={searchAsset} />}
          </div>
         <div className="header-wrapper-background-color"></div>
         {this.state.searchActive && <HeaderSearch active={this.state.searchActive} site={this.props.site} toggleSearch={this.delayedToggleSearch} categories={categories} lines={lines} />}
         {/* !this.props.hideCart && <img className="header-icon" src={GeneralAssetUrl+'cart-white.png'} /> */}
       </div>
       {(this.props.categories && this.props.categories.length > 0) && <HeaderCategoryMenu columns={this.props.categoryColumns} categories={categories} active={this.state.categoryMenuActive} />}
       {(this.props.lines && this.props.lines.length > 0) && <HeaderLineMenu lines={lines} columns={this.props.lineColumns} active={this.state.lineMenuActive} site={this.props.site} />}
       <div className={"header-wrapper header-mobile "+hoverClass+ " "+this.props.site}>
         {this.props.logo && <a href={this.state.baseUrl}><img className="header-logo" src={this.props.logo} /></a>}
         <div onClick={this.toggleMobileMenu} className="header-menu-toggle"><img className="full-width" src={menuAsset} /></div>
         <div className={"header-menu "+mobileActive}>
            <div className="mobile-menu-open-header-top">
              {this.props.logo && <a href={this.state.baseUrl}><img className="mobile-menu-open-logo" src={this.props.logo} /></a>}
              <div className="mobile-menu-open-header-close" onClick={this.toggleMobileMenu}></div>
            </div>
            <Collapsible trigger={this.state.productText}>
              <span>
                {this.props.categories && this.props.categories.length > 0 &&
                  <div className="horizontal-slider">
                    {this.props.categories && this.props.categories.length > 0 && this.props.categories.map((item:any)=>{
                      let image = null;
                      let text = null;
                      let link = null;
                      if(item.image && item.image.src){
                        image = item.image.src
                      }
                      if(item.link){
                        text = item.link.linkText
                        if(item.link.linkUrl){
                          link = item.link.linkUrl.destinationUrl
                        }
                      }
                      return(
                        <div className={"mobile-header-text-over-image-thumb-wrapper "} style={{height:"30vh"}}>
                           <TextOverImageThumb text={text} image={image} link={link} />
                        </div>
                      )
                    })}
                  </div>
                }
                <div>
                  {lines && lines.length > 0 && lines.map((line:any) =>{
                    let title:any = line.title ? line.title : null;
                    let links:any = [];

                    if(line.collabsibleCategoryLinks && line.collabsibleCategoryLinks.length > 0){
                      for (let index = 0; index < line.collabsibleCategoryLinks.length; index++) {
                        let text:any =  line.collabsibleCategoryLinks[index].text
                        let url:any = line.collabsibleCategoryLinks[index].url
                        links.push({
                          text:text,
                          url:url
                        })
                      }
                    }
                    if(line.links && line.links.length > 0){
                      for (let index = 0; index < line.links.length; index++) {
                        let text:any =  line.links[index].text
                        let url:any = line.links[index].url
                        links.push({
                          text:text,
                          url:url
                        })
                      }
                    }
                    return(
                      <div className="line-column" style={{marginLeft:15}}>
                          <Collapsible trigger={title}>
                            {links && links.map((link:any) =>{
                              return(
                                <div  style={{marginLeft:15}}>
                                  <HeaderMenuItem text={link.text} link={link.url} />
                                </div>
                              )
                            })}
                          </Collapsible>
                      </div>
                    )
                  })}
                </div>
                </span>
              </Collapsible>
              {this.props.menuItems && this.props.menuItems.map((item:any)=>{
                let type = item.subMenuArray && item.subMenuArray.length > 0 ? 'accordion' : 'basic';
                if(type == "accordion"){
                  return(
                    <Collapsible trigger={item.link ? item.link.linkText:''}>
                      {item.subMenuArray && item.subMenuArray.length > 0 && item.subMenuArray.map((submenuItem:any) =>{
                        return(
                          <div style={{marginLeft:'20px'}}>
                            <HeaderMenuItem text={submenuItem.linkText ? submenuItem.linkText : ''} link={submenuItem.linkUrl ? submenuItem.linkUrl.destinationUrl : ''} />
                          </div>
                        )
                      })}
                    </Collapsible>
                  )
                } else{
                  return(
                    <HeaderMenuItem text={item.link ? item.link.linkText:''} link={(item.link && item.link.linkUrl) ? item.link.linkUrl.destinationUrl:''} />
                  )
                }
              })}
           </div>

       </div>
      </>
    </StickyHeader>
  );
 }
}

 export default HeaderWrapper;
